import { LoginForm, UserToken, User } from "@/types/auth/user";
import { postWithoutAuth, fetchWithtAuth } from "@/helpers/apiHelper";
import { UserAA } from "@/types/userAA";
import { ApiItem } from "@/types/api";

// #NO_AUTH
export const loginTest = (payload: LoginForm): Promise<UserToken> => {
  return new Promise((resolve, reject) => {
    // Liste user
    fetch("./users.json")
      .then((response) => response.json())
      .then((users) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const user = users.find((u: User) => u.login === payload.login);
        if (user) {
          resolve({
            login: user.login,
            token: user.id,
          });
        } else {
          reject("401");
        }
      });
  });
};
export const login = (payload: LoginForm): Promise<UserToken> => {
  return postWithoutAuth(`login`, payload);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrentUser = async (): Promise<ApiItem<UserAA>> => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const i: any = await fetchWithtAuth(`current_user`);
  //i = i.data;
  i.data = new UserAA(i.data);
  return i;
};

// #NO_AUTH
export const fetchUser = (payload: UserToken): Promise<User> => {
  return new Promise((resolve, reject) => {
    // Liste user
    fetch("./users.json")
      .then((response) => response.json())
      .then((users) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const user = users.find(
          (u: User) => String(u.id) === String(payload.token),
        );
        if (user) {
          resolve(user);
        } else {
          reject("401");
        }
      });
  });
};
// export const login = (): Promise<ApiList<ObjectType>> => {
//   return postWithoutAuth(`login`);
// };

// #NO_AUTH
export const refreshToken = (payload: UserToken): Promise<UserToken> => {
  return new Promise((resolve, reject) => {
    // Liste user
    fetch("./users.json")
      .then((response) => response.json())
      .then((users) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const user = users.find(
          (u: User) => String(u.id) === String(payload.token),
        );
        if (user) {
          resolve(payload);
        } else {
          reject("401");
        }
      });
  });
};
// export const login = (): Promise<ApiList<ObjectType>> => {
//   return postWithoutAuth(`refreshtoken`);
// };
